module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","busyTxt":"Bitte Warten...","errMsg":"Deine Anmeldung war nicht erfolgreich - prüfe Deine Eingaben!","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/login/de.json
// module id = JJzB
// module chunks = 1